import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportInvoicesGroupedTypes, reportInvoicesGroupedLoadings } from "redux/reducers/Reports/reportInvoicesGrouped/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_INVOICES_GROUPED_FILTERS } = reportInvoicesGroupedTypes;
const { GET_REPORT } = reportInvoicesGroupedLoadings;

export const getReportInvoicesGroupedAction = ({ startDate, endDate, stations = [], isPdf = true }) => {
  return async (dispatch, getState) => {
    dispatch(startRequestComp(GET_REPORT));
    try {
      const token = getState().login.token || localStorage.getItem('crm-user');
      const stationsParams = stations.map(({ id }) => `stations=${id}`).join('&');
      const stationsNames = stations.length === 1 ? stations[0].name : `${stations.length}_Plantas`;
      const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/invoices/report/grouped?${stationsParams}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const fileName = `Reporte_Agrupado_Listado_Facturacion_${stationsNames}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp(GET_REPORT));
    }
  };
};

export const setReportInvoicesGroupedFilters = (key = "", value) => ({
  type: SET_INVOICES_GROUPED_FILTERS,
  payload: { key, value }
});
